module.exports = __webpack_public_path__ + "static/media/icona_rimedi.5c71da22.png";


//////////////////
// WEBPACK FOOTER
// ./src/include/icona_rimedi.png
// module id = 320
// module chunks = 0